import React, {useState, useEffect, useRef} from 'react'
import { Link } from 'react-router-dom';
import { faPencil, faTrash, faTimesCircle, faArrowUp, faArrowDown, faEllipsisV, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import {useDispatch, useSelector} from 'react-redux';
import { topicData, setTopic, setTopicComponents } from '../../slices/topicSlice';
import { displayEditorUtil } from '../../utils/topicUtils';
import axios from 'axios';
import { API_URL } from '../../global/components/Constants';
import Confirm from '../../global/components/Confirm';
import '../../global/components/scroll-bar.css';
import { 
    getTopicComponents, 
    deleteTopicComponent, 
    swapTopicComponentRank } from '../../utils/api-services/topic';
import { parseMarginPadding } from '../../utils/controlUtils';
import TopicComponentListItem from './TopicComponentListItem';
import ComponentItem from './ComponentItem';

const TopicCompContainer = ({obj, index, edit}) => {

    const [components, setComponents] = useState([]);
    const [confirm, setConfirm] = useState(false);
    const [hover, setHover] = useState(false);
    const [compSelect, setCompSelect] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [componentLoading, setComponentLoading] = useState(false);
    const itemRef = useRef();
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topic = tpicData.topic;
    const topicComponents = tpicData.topicComponents;

    const content = JSON.parse(obj.Content);
    const title = content.Title;
    const display = content.Display;
    const desc = content.Description;
    const align = content.Align;
    const theme = content.Theme;
    const size = content.Size;
    const spacing = content.ItemSpacing;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0;
    if(size == "small"){ titleSz=20; textSz=14 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=38; textSz=24 }

    let space = 0;
    if(spacing == "small"){ space = 20; }
    else if(spacing == "medium"){ space = 30; }
    else if(spacing == "large"){ space = 40; }

    useEffect(()=>{
        loadComponents();
    }, []);

    function loadComponents(){
        setComponentLoading(true);
        axios({
            method: 'get',
            url: API_URL + `topic/components`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setComponents(obj.Data);
            }
            setComponentLoading(false);
        });
    }

    const showEditModal = ()=>{
        setEditModal(true);
    }

    const closeEditModal = ()=>{
        setEditModal(false);
    }

    function editItem(){
        showEditModal();
    }

    async function sortComponent(direction){
        let toIndex = 0;
    
        if(direction == "up"){ toIndex = index - 1; }
        else if(direction == "down"){ toIndex = index + 1; }
        const toObj = topicComponents[toIndex];
    
        const fromId = parseInt(obj.Id)
        const fromRank = obj.Rank
        const toId = parseInt(toObj.Id);
        const toRank = toObj.Rank;
    
        const saveRecord = await swapTopicComponentRank({
            fromId: fromId,
            fromRank: fromRank,
            toId: toId,
            toRank: toRank
        });
                            
        if(saveRecord.Success){
            loadTopicComponents();
        }
    }

    const deleteItem = async () => {
        const deleteRecord = await deleteTopicComponent({id: obj.Id}); 
        if(deleteRecord.Success){
            loadTopicComponents();
        }
    }
    
    const loadTopicComponents = async () => {
        const data = await getTopicComponents(obj.TopicSlug);
        dispatch(setTopicComponents(data));
    }

    function confirmDelete(){
        setConfirm(true);
    }

    const showSelect = ()=>{
        setCompSelect(true);
    }

    const closeSelect = ()=>{
        setCompSelect(false);
    }

    const styles = {
        container:{
            background: bgColor,
            minHeight: 200,
            position: 'relative',
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        head:{
            marginBottom: 10
        },
        title:{
            color: txtColor,
            marginBottom: 5,
            fontSize: titleSz,
            textAlign: align,
            fontWeight: 600
        },
        desc:{
            color: txtColor,
            fontSize: textSz,
            textAlign: align
        },
        hr: {
            borderColor: extra3
        },
        body:{
            display: 'flex',
            flexDirection: display,
            alignItems: 'center',
            padding: isMobile? 10: 0,
            overflowX: 'scroll'
        },
        containerItem:{
            flex: 1,
            marginRight: space
        },
        compSelect:{
            body:{
                display: compSelect? 'block': 'none',
                background: '#fff',
                padding: 20,
                position: 'absolute',
                top: 20,
                left: 20,
                right: 20,
                bottom: 20,
                zIndex: 9999,
                borderRadius: 5
            },
            title:{
                color: '#666',
                marginBottom: 20,
                fontSize: 16,
                fontWeight: 600
            },
            add: {
                textAlign: 'center'
            },
            addBtn:{
                background: '#fff',
                color: '#888',
                padding: '7px 10px',
                border: 'none',
                borderRadius: 3,
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
                textDecoration: 'none'
            },
            closeBtn:{
                color: '#ccc',
                position: 'absolute',
                top: 10,
                right: 10,
                fontSize: 20
            }
        },
        actions: {
            container: {
                position: 'absolute',
                top: 0,
                right: -15
            },
            btn:{
                color: hover?'#00667d':'#888',
                background: hover?'#efefef':'#fff',
                padding: '7px 10px',
                border: 'none',
                borderRadius: 3,
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none'
            },
            option:{
                fontSize: 14,
            },
            optionRed:{
                color: '#ff6d6d',
                fontSize: 14,
            },
        },
    }

    let containerEditorParams = {
        topic: topic,
        obj: obj,
        componentType: obj.ComponentType,
        editor: obj.Editor,
        containerId: obj.ContainerId,
        action: "edit",
        close: closeEditModal,
    }

    const confirmParams = {
        title: "Remove",
        info: "Do you want to remove?",
        confirm: confirm, 
        setConfirm: setConfirm, 
        action:deleteItem
    }

    function actions(){
        return(
            <div class="dropdown">
                <button type="button" data-toggle="dropdown" style={styles.actions.btn} onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <Link onClick={()=>{editItem()}} class="dropdown-item" style={styles.actions.option}>
                        <FontAwesomeIcon icon={faPencil} /> &nbsp;&nbsp;&nbsp;&nbsp; Edit
                    </Link>

                    {topicComponents[index - 1] &&
                        <>
                            <div className="dropdown-divider"></div>
                            <Link onClick={()=>{sortComponent("up")}} class="dropdown-item" style={styles.actions.option}>
                                <FontAwesomeIcon icon={faArrowUp} /> &nbsp;&nbsp;&nbsp;&nbsp; Move Up
                            </Link>
                        </>
                    }
                    
                    {topicComponents[index + 1] &&
                        <>
                            <div className="dropdown-divider"></div>
                            <Link onClick={()=>{sortComponent("down")}} class="dropdown-item" style={styles.actions.option}>
                                <FontAwesomeIcon icon={faArrowDown} /> &nbsp;&nbsp;&nbsp;&nbsp; Move Down
                            </Link>
                        </>
                    }

                    <div className="dropdown-divider"></div>
                    <Link onClick={()=>{confirmDelete()}} class="dropdown-item" style={styles.actions.optionRed}>
                        <FontAwesomeIcon icon={faTrash} /> &nbsp;&nbsp;&nbsp;&nbsp; Delete
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.container}>
            {edit && <div style={styles.actions.container}>{actions()}</div>}
            
            {(title != "" || desc != "") &&
                <div style={styles.head}>
                    <>
                        {(title != "") && <h2 style={styles.title}>{title}</h2>}
                        {(desc != "") && <div style={styles.desc}>{desc}</div>}
                        <hr style={styles.hr} />
                    </>
                </div>
            }
            
            <div style={styles.body} className='hide-scroll-bar'>
                {obj.Sub.map((itm, index)=>(
                    <div style={styles.containerItem}>
                        <TopicComponentListItem 
                            key={itm.Id} 
                            obj={itm} 
                            index={index} 
                            edit={edit} 
                        /> 
                    </div>
                ))}
            </div>
            
            {edit && 
                <div style={styles.compSelect.add}>
                    {(obj.Sub.length > 0) && <hr style={styles.hr} />}
                    <Link onClick={showSelect} style={styles.compSelect.addBtn} className='btn-sm'>
                        <FontAwesomeIcon icon={faPlus} /> ADD COMPONENT
                    </Link>
                </div>
            }

            <div style={styles.compSelect.body}>
                <h4 style={styles.compSelect.title}>Add element to container</h4>
                <Link onClick={closeSelect}  style={styles.compSelect.closeBtn}>
                    <FontAwesomeIcon icon={faTimesCircle}  />
                </Link>
                {components.map(itm => (
                    (itm.ComponentType != "container") && <ComponentItem topic={topic} obj={itm} containerId = {obj.Id} closeSelect={closeSelect} />
                ))}
            </div>

            <Modal size='lg' show={editModal} onHide={closeEditModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>Container Editor</Modal.Title>
                    <button type="button" onClick={closeEditModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body style={{padding:0}}>  
                    {displayEditorUtil(containerEditorParams)}
                </Modal.Body> 
            </Modal>

            <Confirm params={confirmParams} />
        </div> 
    )
}

export default TopicCompContainer